import React from 'react'
import { connect } from 'react-redux'
import {  setActiveOrderCard} from '../../../redux/card-reducer'
import CardsList from './CardsList'



class CardsListContainer extends React.Component{
    render(){
        return(
            <CardsList {...this.props}/>
        )
    }
}


const mapStateToProps = (state) =>{
    return{
        cardTypeData: state.cardPage.cardTypeData
    }
}

export default connect(mapStateToProps,{
    setActiveOrderCard
})(CardsListContainer)